import { Component, Input, OnInit } from '@angular/core';
import { ConfigSystemParams } from 'src/app/core/consts';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss']
})

export class BreadcrumbsComponent implements OnInit {

  @Input() breadcrumbItems!: Array<{ active?: boolean; label?: string; }>;
  @Input() title           : string | undefined;
  
  get showBreadcrumbs() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ShowBreadcrumbs, false ); }

  constructor(
    private configSystemService: ConfigSystemService
  ) { }

  public ngOnInit(): void { }
}
